import React from 'react';
import client from '../../httpclient';
import { defaultApiErrorHandler } from '@/helpers/string';

const useTQuery = (url: string, postMethod?: boolean) => {
  const [data, setData] = React.useState<any>();

  const [loading, setLoading] = React.useState(false);
  const getData = (query: any) => {
    setLoading(true);
    if (postMethod) {
      client
        .post(url, query)
        .then(d => {
          setData(d.data);
        })
        .catch(defaultApiErrorHandler)
        .finally(() => {
          setLoading(false);
        });
    } else {
      client
        .get(url, { params: query })
        .then(d => {
          setData(d.data);
        })
        .catch(defaultApiErrorHandler)
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return [
    getData,
    {
      data: data,
      loading: loading,
    } as any,
  ];
};
export default useTQuery;
